var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Radio, Label } from 'flowbite-react';
import { isString } from 'lodash';
import { Translate } from "../../../I18N";













const RadioSelect = ({
  legend,
  options,
  name,
  onChange,
  className,
  orientation = 'vertical'
}) => /*#__PURE__*/
_jsx("div", { className: "tw-content" }, void 0, /*#__PURE__*/
_jsx("fieldset", {
  className: `flex flex-wrap gap-4 ${
  orientation === 'vertical' ? 'flex-col max-w-md' : ''
  } ${className}`,
  id: `radio_${name}` }, void 0,

legend && /*#__PURE__*/_jsx("legend", { className: "mb-4" }, void 0, legend),
options.map((option) => /*#__PURE__*/
_jsx("div", {
  className: `flex items-center gap-2 ${orientation === 'vertical' ? '' : 'mr-4'}` },
option.id || option.value, /*#__PURE__*/

_jsx(Radio, {
  id: `${name}_${option.value}`,
  name: name,
  value: option.value,
  disabled: option.disabled || false,
  defaultChecked: option.defaultChecked,
  onChange: onChange }
), /*#__PURE__*/
_jsx(Label, {
  htmlFor: `${name}_${option.value}`,
  className: option.disabled ? '!text-gray-300' : '' }, void 0,

isString(option.label) ? /*#__PURE__*/_jsx(Translate, {}, void 0, option.label) : option.label
)
)
)
)
);


export { RadioSelect };